import React, { useEffect } from "react";
import Hero from "../components/Hero";
import Overview from "../components/Overview";
import FeaturedProjects from "../components/FeaturedProjects";
import Services from "../components/Services";
import Process from "../components/Process";
import Values from "../components/Values";
import ContactCTA from "../components/ContactCTA";

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <main>
      <Hero />
      <Overview />
      <FeaturedProjects />
      <Services />
      <Process />
      <Values />
      <ContactCTA />
    </main>
  );
}
